export default function reachPanel() {
  return {
    island: 'jersey',
    mapReady: false,
    observer: null,
    timer: null,
    init() {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.mapReady = true;
        return;
      }

      const revealMap = () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.mapReady = true;
        }, 2820);
      };

      if (this.$el.classList.contains('is-visible')) {
        revealMap();
        return;
      }

      this.observer = new MutationObserver(() => {
        if (!this.$el.classList.contains('is-visible')) return;
        this.observer?.disconnect();
        this.observer = null;
        revealMap();
      });

      this.observer.observe(this.$el, {
        attributes: true,
        attributeFilter: ['class'],
      });
    },
    destroy() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
    },
  };
}
